import { createSelector } from 'reselect';

const EMPTY = Object.freeze({});
const inningStateMap = {
    Middle: 'mid',
    End: 'end'
};

const getCommercialBreak = (state) => state?.commercialBreak;
const getInningState = (state) => getCommercialBreak(state)?.inningState;
const getCurrentInning = (state) => getCommercialBreak(state)?.currentInning;
const getInnings = (state) => getCommercialBreak(state)?.midInningAdConfig?.innings;
const getAdEnded = (state) => getCommercialBreak(state)?.adEnded;
const getAdStarted = (state) => getCommercialBreak(state)?.adStarted;
const getShowVideoAds = (state) => state?.config?.showVideoAds;
const getPremiumUser = (state) => state?.config?.isPremiumUser;
const getAdPlayed = (state) => getCommercialBreak(state)?.adPlayed;
const getIsCommercialBreak = (state) => getCommercialBreak(state)?.isCommercialBreak;
const getTransitionFromBreak = (state) => getCommercialBreak(state)?.transitionFromBreak;
const getTransitionToBreak = (state) => getCommercialBreak(state)?.transitionToBreak;

export const getCommercialBreakState = createSelector(
    [getAdPlayed, getIsCommercialBreak, getTransitionFromBreak, getTransitionToBreak, getShowVideoAds, getAdEnded, getInnings, getInningState, getCurrentInning, getPremiumUser, getAdStarted],
    (adPlayed, isCommercialBreak, transitionFromBreak, transitionToBreak, vidAdsEnabled, adEnded, innings, inningState, currentInning, isPremiumUser, adStarted) => {
        let adType = 'video';
        let showMidInnigAd = (typeof isPremiumUser === 'undefined');

        if (typeof innings !== 'undefined') {
            const adTypeConfig = (innings?.[`${currentInning}`] ?? innings.extra);
            const { premium, video } = adTypeConfig?.[inningStateMap?.[inningState]] || EMPTY;
            if (!video) {
                adType = 'banner';
            }

            if (isPremiumUser && premium) {
                showMidInnigAd = true;
            }
        }

        return {
            adPlayed,
            isCommercialBreak,
            transitionFromBreak,
            transitionToBreak,
            vidAdsEnabled,
            adEnded,
            adType,
            showMidInnigAd,
            adStarted
        };
    }
);
